import ApiModel from 'models/api-model';
import { isNullOrUndefined } from 'utils/object-utils';
import LinkedStatementModel from 'models/data/linked-statement-model';

export default class LinkedStatementListModel extends ApiModel({
  data: [],
}) {
  get hasLength() {
    return this.data.length > 0;
  }

  get statementList() {
    return this.data;
  }

  removeStatementFromList(clientId, statementId, revisionId) {
    this.data = this.data.filter(
      (statement) =>
        !(
          statement.statementId === statementId &&
          statement.clientId === clientId &&
          statement.revisionId === revisionId
        ),
    );
    return this.merge({
      data: this.data,
    });
  }

  updateStatusByClientStatementRevision(payload) {
    const { clientId, statementId, revisionId, workflowStatus } = payload;
    this.data = this.data.map((statement) => {
      if (
        statement.statementId === statementId &&
        statement.clientId === clientId &&
        statement.revisionId === revisionId
      ) {
        return { ...statement, workflowStatus };
      }
      return statement;
    });
    return this.merge({
      data: this.data,
    });
  }

  get revisionIdToStatementMap() {
    const map = new Map();
    this.data.forEach((statement) => {
      map.set(statement?.revisionId, statement);
    });
    return map;
  }

  processResponse(response) {
    if (
      response?.data?.result?.length === 0 ||
      isNullOrUndefined(response?.data?.result)
    ) {
      return { data: [] };
    }
    return {
      data: response?.data?.result.map(
        (item) => new LinkedStatementModel(item),
      ),
    };
  }
}
